import { communityReviewEndpointIds } from 'root/src/server/modules/communityReview/communityReview.fixture';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getDropCommunityReviewsEndpoint = {
    [communityReviewEndpointIds.GET_DROP_COMMUNITY_REVIEWS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                page: { type: 'number' },
                limit: { type: 'number' },
                value: { type: 'string' },
                sort: {
                    type: 'object',
                    properties: {
                        field: { type: 'string' },
                        order: { type: 'string', enum: ['asc', 'desc'] },
                    },
                },
            },
            required: ['dropId'],
        },
    },
};
